/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.content.grid.layouts.rpc.GridLayoutsRpc
 */

export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const ContainerTypename = 'com.hubspot.content.grid.layouts.models.components.Container';
export const GridContainerLayoutTypename = 'com.hubspot.content.grid.layouts.models.components.GridContainerLayout';
export const GridLayoutTypename = 'com.hubspot.content.grid.layouts.models.components.GridLayout';
export const GridLayoutWithMetaTypename = 'com.hubspot.content.grid.layouts.models.components.GridLayoutWithMeta';
export const ModuleTypename = 'com.hubspot.content.grid.layouts.models.components.Module';
export const PegboardContainerLayoutTypename = 'com.hubspot.content.grid.layouts.models.components.PegboardContainerLayout';
export const StackContainerLayoutTypename = 'com.hubspot.content.grid.layouts.models.components.StackContainerLayout';
export const ReusableBlockContentBaseTypename = 'com.hubspot.content.grid.layouts.models.components.base.ReusableBlockContentBase';
export const ReusableBlockWithMetaTypename = 'com.hubspot.content.grid.layouts.models.components.blocks.ReusableBlockWithMeta';
export const SectionReusableBlockTypename = 'com.hubspot.content.grid.layouts.models.components.blocks.SectionReusableBlock';
export const ContainerStructureTypename = 'com.hubspot.content.grid.layouts.models.data.structure.ContainerStructure';
export const GridLayoutStructureEntityTypename = 'com.hubspot.content.grid.layouts.models.data.structure.GridLayoutStructureEntity';
export const ModuleStructureTypename = 'com.hubspot.content.grid.layouts.models.data.structure.ModuleStructure';
export const ReusableBlockStructureEntityTypename = 'com.hubspot.content.grid.layouts.models.data.structure.blocks.ReusableBlockStructureEntity';
export const SectionReusableBlockStructureTypename = 'com.hubspot.content.grid.layouts.models.data.structure.blocks.SectionReusableBlockStructure';
export const AutoPositionTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.AutoPosition';
export const AutoRowOrColumnSizeTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.AutoRowOrColumnSize';
export const FitContentWidthTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.FitContentWidth';
export const FullContentWidthTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.FullContentWidth';
export const ManualPositionTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.ManualPosition';
export const MaxContentRowOrColumnSizeTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.MaxContentRowOrColumnSize';
export const MaxContentWidthTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.MaxContentWidth';
export const MinContentRowOrColumnSizeTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.MinContentRowOrColumnSize';
export const MinMaxRowOrColumnSizeTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.MinMaxRowOrColumnSize';
export const SizedContentRowOrColumnSizeTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.SizedContentRowOrColumnSize';
export const SizedWidthTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.SizedWidth';
export const SplitGapTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.SplitGap';
export const UnifiedGapTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.UnifiedGap';
export const BackgroundColorLayerTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.background.BackgroundColorLayer';
export const BackgroundGradientLayerTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.background.BackgroundGradientLayer';
export const BackgroundImageLayerTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.background.BackgroundImageLayer';
export const BackgroundVideoLayerTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.background.BackgroundVideoLayer';
export const KeywordBorderWidthTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.border.KeywordBorderWidth';
export const SizedBorderWidthTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.border.SizedBorderWidth';
export const BlurFilterTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.BlurFilter';
export const BrightnessFilterTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.BrightnessFilter';
export const ContrastFilterTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.ContrastFilter';
export const DropShadowFilterTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.DropShadowFilter';
export const FilterUrlTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.FilterUrl';
export const GrayscaleFilterTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.GrayscaleFilter';
export const HueRotateFilterTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.HueRotateFilter';
export const InvertFilterTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.InvertFilter';
export const OpacityFilterTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.OpacityFilter';
export const SaturateFilterTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.SaturateFilter';
export const SepiaFilterTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.SepiaFilter';
export const BrightnessOffsetModifierTypename = 'com.hubspot.content.model.customwidgets.inherited.BrightnessOffsetModifier';
export const ShadeModifierTypename = 'com.hubspot.content.model.customwidgets.inherited.ShadeModifier';
export const ShadeOffsetModifierTypename = 'com.hubspot.content.model.customwidgets.inherited.ShadeOffsetModifier';
export const getCombinedGridLayoutByIdRpc = {
  serviceName: 'com.hubspot.content.grid.layouts.rpc.GridLayoutsRpc',
  rpcName: 'getCombinedGridLayoutById',
  auth: 'app',
  fingerprint: 'vw0z7z8_hAMdy8KRSohfMev06IyPScbK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCombinedGridLayoutByDndAreaNameRpc = {
  serviceName: 'com.hubspot.content.grid.layouts.rpc.GridLayoutsRpc',
  rpcName: 'getCombinedGridLayoutByDndAreaName',
  auth: 'app',
  fingerprint: 'Cm8r0up5v1Ady8KRSohfMev06IyPScbK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCombinedGridLayoutsForObjectIdRpc = {
  serviceName: 'com.hubspot.content.grid.layouts.rpc.GridLayoutsRpc',
  rpcName: 'getCombinedGridLayoutsForObjectId',
  auth: 'app',
  fingerprint: 'Wg-csjReJxcn9kF4xTxr9ev06IyPScbK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createGridLayoutFromCombinedModelRpc = {
  serviceName: 'com.hubspot.content.grid.layouts.rpc.GridLayoutsRpc',
  rpcName: 'createGridLayoutFromCombinedModel',
  auth: 'app',
  fingerprint: 'PY03MWNSa6a9IX0D1RC1Iev06IyPScbK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkCreateGridLayoutFromCombinedModelRpc = {
  serviceName: 'com.hubspot.content.grid.layouts.rpc.GridLayoutsRpc',
  rpcName: 'bulkCreateGridLayoutFromCombinedModel',
  auth: 'app',
  fingerprint: 'NlVO3yFG_Q0n9kF4xTxr9ev06IyPScbK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createGridLayoutFromCombinedModelV2Rpc = {
  serviceName: 'com.hubspot.content.grid.layouts.rpc.GridLayoutsRpc',
  rpcName: 'createGridLayoutFromCombinedModelV2',
  auth: 'app',
  fingerprint: 'zGX21sG0CsoUDgRvldMlH-v06IyPScbK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkCreateGridLayoutFromCombinedModelV2Rpc = {
  serviceName: 'com.hubspot.content.grid.layouts.rpc.GridLayoutsRpc',
  rpcName: 'bulkCreateGridLayoutFromCombinedModelV2',
  auth: 'app',
  fingerprint: 'FB41bzvUYKIn9kF4xTxr9ev06IyPScbK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkUpsertGridLayoutFromCombinedModelRpc = {
  serviceName: 'com.hubspot.content.grid.layouts.rpc.GridLayoutsRpc',
  rpcName: 'bulkUpsertGridLayoutFromCombinedModel',
  auth: 'app',
  fingerprint: 'f8oLEYFXIMEn9kF4xTxr9ev06IyPScbK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateGridLayoutFromCombinedModelRpc = {
  serviceName: 'com.hubspot.content.grid.layouts.rpc.GridLayoutsRpc',
  rpcName: 'updateGridLayoutFromCombinedModel',
  auth: 'app',
  fingerprint: 'SI9CKlvR4boUDgRvldMlH-v06IyPScbK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const permanentlyDeleteGridLayoutsForObjectRpc = {
  serviceName: 'com.hubspot.content.grid.layouts.rpc.GridLayoutsRpc',
  rpcName: 'permanentlyDeleteGridLayoutsForObject',
  auth: 'app',
  fingerprint: 'b18KhDFL7rlcyRhcoXaq1ev06IyPScbK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getVersionsByGridIdRpc = {
  serviceName: 'com.hubspot.content.grid.layouts.rpc.GridLayoutsRpc',
  rpcName: 'getVersionsByGridId',
  auth: 'app',
  fingerprint: 'vM-g3FMScpLRckE2hVHSqOv06IyPScbK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getVersionsByObjectVersionIdRpc = {
  serviceName: 'com.hubspot.content.grid.layouts.rpc.GridLayoutsRpc',
  rpcName: 'getVersionsByObjectVersionId',
  auth: 'app',
  fingerprint: '0Uip7zfMUY3RckE2hVHSqOv06IyPScbK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const restoreVersionsByObjectVersionIdRpc = {
  serviceName: 'com.hubspot.content.grid.layouts.rpc.GridLayoutsRpc',
  rpcName: 'restoreVersionsByObjectVersionId',
  auth: 'app',
  fingerprint: 'yOmlxJaL3c8G290O_1shB-v06IyPScbK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};